<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormOtherSourcesData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INCOME FROM OTHER SOURCES</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <ng-container *ngFor="let item of incomeFormOtherSourcesData; let idx = index">
    <!-- SRO: 2-column Particulars / Amount table -->
    <ng-container *ngIf="isSroType(getIfosType(item))">
      <ng-container *ngFor="let detail of getIfosDetails(item); let detailIdx = index">
        <div style="page-break-inside: avoid;" class="row mb-5">
          <div class="col-12 mb-3">
            <div class="return-view-text-fields">
              <div class="return-view-text-field">
                <span class="return-view-text-label">Income Type:</span>
                <span class="return-view-text-value">{{ getIfosTypeTitle(getIfosType(item)) }}</span>
              </div>
              <ng-container *ngFor="let particular of sroTextParticulars">
                <div class="return-view-text-field" *ngIf="hasSroValue(item, detail, particular)">
                  <span class="return-view-text-label">{{ particular.title }}:</span>
                  <span class="return-view-text-value">{{ getSroValue(item, detail, particular) }}</span>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="col-12 mt-2">
            <table class="table table-bordered income-other-sources-table">
              <thead>
                <tr class="text-center">
                  <th style="width: 70%">Particulars</th>
                  <th style="width: 30%">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let particular of sroAmountParticulars">
                  <ng-container
                    *ngIf="hasSroValue(item, detail, particular) && (particular.scope !== 'parent' || detailIdx === 0)"
                  >
                    <td>{{ particular.title }}</td>
                    <td class="text-right pr-3">
                      {{ getSroValue(item, detail, particular) | currencySeparatorBD }}
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Non-SRO: multi-column table -->
    <ng-container *ngIf="!isSroType(getIfosType(item)) && getIfosDetails(item).length">
      <div style="page-break-inside: avoid;" class="row mb-5">
        <div class="col-12 text-center font-weight-bold mb-3">
          {{ getIfosTypeTitle(getIfosType(item)) }}
        </div>

        <div class="col-12" *ngIf="getTableColumns(getIfosType(item)) as columns">
          <table class="table table-bordered income-other-sources-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th *ngFor="let col of columns">{{ col.title }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of getIfosDetails(item); let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td
                  *ngFor="let col of columns"
                  [ngClass]="{ 'text-right pr-3': col.isAmount }"
                >
                  <ng-container *ngIf="col.isAmount">
                    {{ getCellValue(detail, col) | currencySeparatorBD }}
                  </ng-container>
                  <ng-container *ngIf="!col.isAmount">
                    {{ getCellValue(detail, col) }}
                  </ng-container>
                </td>
              </tr>
              <tr class="font-weight-bold">
                <td></td>
                <td
                  *ngFor="let col of columns; let colIdx = index"
                  [ngClass]="{
                    'text-center': !col.isAmount && colIdx === getTotalLabelColumnIndex(columns),
                    'text-right pr-3': col.isAmount
                  }"
                >
                  <ng-container *ngIf="!col.isAmount && colIdx === getTotalLabelColumnIndex(columns)">
                    Total
                  </ng-container>
                  <ng-container *ngIf="col.isAmount">
                    {{ getColumnTotal(getIfosDetails(item), col) | currencySeparatorBD }}
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
